function percentChange(current, prior) {
  if (current == null || prior == null) return null;
  if (prior === 0) {
    if (current === 0) return 0;
    return null;
  }
  return ((current - prior) / prior) * 100;
}

function formatPercentChange(pct) {
  if (pct == null || Number.isNaN(pct)) return '—';
  const rounded = Math.round(pct * 10) / 10;
  const sign = rounded > 0 ? '+' : '';
  return `${sign}${rounded}%`;
}

function formatCountChange(current, prior) {
  const currentNumber = Number(current);
  const priorNumber = Number(prior);
  if (!Number.isFinite(currentNumber) || !Number.isFinite(priorNumber)) return null;
  if (priorNumber === 0) return currentNumber === 0 ? '0' : null;
  const delta = Math.round(currentNumber - priorNumber);
  return `${delta > 0 ? '+' : ''}${delta}`;
}

export default function PeriodDelta({ current, prior, mode = 'percent' }) {
  if (prior == null) return null;
  const countDisplay = mode === 'count' ? formatCountChange(current, prior) : null;
  const pct = percentChange(current, prior);
  const display = countDisplay ?? formatPercentChange(pct);
  if (display === '—') return null;
  const numeric =
    mode === 'count' && countDisplay != null
      ? Number(countDisplay)
      : pct;
  const direction = numeric == null || Number.isNaN(numeric) ? 'neutral' : numeric > 0 ? 'up' : numeric < 0 ? 'down' : 'neutral';
  return (
    <p className={`period-delta period-delta-${direction}`} aria-label={`vs prior period: ${display}`}>
      {mode === 'count' ? null : (
        <>
          <span aria-hidden="true">{direction === 'up' ? '↑' : direction === 'down' ? '↓' : '→'}</span>{' '}
        </>
      )}
      {display}
      <span className="period-delta-label">{mode === 'count' ? ' vs prior' : ' vs prior period'}</span>
    </p>
  );
}
